<template>
  <div data-type="input" class="input">
    <PreviewImage v-if="showImageLoader" :input-name="inputName"/>

    <input
      :id="inputId"
      v-replace="/\s/"
      :class="{ 'invalid': $v.$error }"
      :size="inputSize"
      type="url"
      :value="value"
      :title="inputTitle"
      :placeholder="inputPlaceholder"
      :disabled="disabled"
      :readonly="readonly"
      autocomplete="off"
      @input="inputHandler"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
    />

    <label :for="inputId">
      <span> {{ inputName }} </span>
      <span v-if="isCounter(this.showCounter, this.maxLength, this.value)"> {{ getCounter(this.maxLength, this.value) }} </span>
      <span v-if="$v.$error" class="validation" :title="getValidationInfo($v)"><mark></mark></span>
      <span v-if="readonly" class="lock"><mark></mark></span>
      <a v-if="capustaInfo" class="hint" @click.prevent="$showInfo(capustaInfo)"></a>
    </label>

    <slot name="link"></slot>
  </div>
</template>

<script>
import { requiredIf, minLength, maxLength } from 'vuelidate/lib/validators';
import { isUrl } from './CustomValidators';

import { getCounter, isCounter, getValidationInfo } from '@/services/inputMixins';

import PreviewImage from '@/components/inputElements/PreviewImage';

export default {
  name: 'InputLink',
  mixins: [getCounter, isCounter, getValidationInfo],
  components: { PreviewImage },
  props: {
    value: [Number, String],
    inputName: String,
    inputTitle: String,
    inputPlaceholder: String,
    inputId: String,
    capustaInfo: String,
    disabled: Boolean,
    readonly: Boolean,
    inputSize: { type: String, default: '12' },
    minLength: { type: Number, default: 0 },
    maxLength: { type: Number, default: 255 },
    required: { type: Boolean, default: true },
    showCounter: { type: Boolean, default: true },
    showImageLoader: { type: Boolean, default: false },
  },
  validations() {
    return {
      value: {
        required: requiredIf(() => this.required),
        minLength: minLength(this.minLength),
        maxLength: maxLength(this.maxLength),
        isUrl,
      },
    };
  },
  methods: {
    inputHandler(e) {
      this.$emit('input', e.target.value.trim());
      this.$v.$touch();
    },
    showInfo() {
      this.$showInfo(this.capustaInfo);
    },
  },
};
</script>
